import React, {useEffect} from "react";
import {Flex, Row, Col, Button, Upload, message} from "antd";
import {CenteredDesign} from "../../../../../components/DesignSystem/CenteredDesign/CenteredDesign";
import {ArticleHeader, ArticleParagraph} from "../../../../../components/DesignSystem/Articles/Articles";
import {UserFilesList} from "./UserFilesList";
import {fileService} from "../../../../../services/fileService";
import {UploadOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";

export const DatasetsPage = ({user}) => {

    const history = useHistory();
    const [data, setData] = React.useState([]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        fileService.fetchAllFiles(1, 2000).then(response => {
            console.log("Fetched datasets:", response.data);
            setData(response.data.content);
        }).catch(error => {
            message.error("Failed to load datasets. Please try again later.");
            // Handle error appropriately, e.g., show a notification or redirect
        });
    }

    const handleFileUpload = () => {
        history.push('/view');
    }


    return <CenteredDesign>
        <Flex justify={"center"} vertical>
            <ArticleHeader>Datasets</ArticleHeader>
            <ArticleParagraph>Browse and analyze datasets in apimoon</ArticleParagraph>
        </Flex>
        <Row>
            <Col span={12}>
                <h4>Uploaded files</h4>
            </Col>
            <Col span={12} style={{textAlign: 'right'}}>
                <Button icon={<UploadOutlined/>} onClick={() => handleFileUpload()} style={{marginBottom: '16px'}}>Open file</Button>
            </Col>
        </Row>
        <UserFilesList data={data} onDeleted={loadData}/>
    </CenteredDesign>

}